import { Box, useSlotRecipe } from '@chakra-ui/react';

import { Spinner } from '@nocowanie/common-ui/components/atoms/spinner';

import { StickySpinnerProps } from './sticky-spinner.props';

export const StickySpinner = ({ isLoading, ...rest }: StickySpinnerProps): JSX.Element => {
    const recipe = useSlotRecipe({
        key: 'stickySpinner',
    });
    const styles = recipe();

    return (
        <Box css={styles.wrapper} hidden={!isLoading} {...rest}>
            <Spinner p={1} display={'inline-flex'} css={styles.spinner} />
        </Box>
    );
};
